
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snehove-zpravodajstvi",
      function () {
        return require("private-next-pages/[region]/[resort]/snehove-zpravodajstvi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snehove-zpravodajstvi"])
      });
    }
  